import { render, staticRenderFns } from "./CoverageTypes.vue?vue&type=template&id=5a0b0091"
import script from "./CoverageTypes.vue?vue&type=script&lang=js"
export * from "./CoverageTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports